module.exports = __webpack_public_path__ + "img/m_bg8.7d89a973.png";